import React from "react";
import { Grid, Card, CardContent, Typography, useTheme, Container, Box } from "@mui/material";
import { Code, PhoneIphone, BusinessCenter, CloudQueue, BugReport, Shield } from "@mui/icons-material"; // Colorful icons
import PageTransition from "./PageTransition";

const services = [
  {
    title: "Fullstack Development",
    description:
      "End-to-end solutions from front-end frameworks like React, to back-end technologies such as Node.js and Java. We create scalable applications with the best architecture for your needs.",
    icon: <Code fontSize="large" sx={{ color: "white" }} />, // Pink color
    bgColor: "linear-gradient(145deg, #6a1b9a, #8e24aa)",
  },
  {
    title: "Mobile Responsive Web Apps",
    description:
      "Optimized mobile-first designs ensuring smooth user experience across all devices. From e-commerce to custom solutions, we deliver responsive, fast, and reliable apps.",
    icon: <PhoneIphone fontSize="large" sx={{ color: "white" }} />, // Teal color
    bgColor: "linear-gradient(145deg, #009688, #80cbc4)",
  },
  {
    title: "Business Solutions",
    description:
      "Custom ERP systems, CRM platforms, and data-driven solutions that drive efficiency and growth. Our business solutions are tailored to scale with your unique needs.",
    icon: <BusinessCenter fontSize="large" sx={{ color: "white" }} />, // Orange color
    bgColor: "linear-gradient(145deg, #0288d1, #03a9f4)",
  },
  {
    title: "Cloud Management",
    description:
      "Scalable and secure cloud management services. Our services ensure smooth deployment, monitoring, and optimization across public, private, and hybrid clouds.",
    icon: <CloudQueue fontSize="large" sx={{ color: "white" }} />, // Green color
    bgColor: "linear-gradient(145deg, #0288d1, #01579b)",
  },
  {
    title: "Testing & QA",
    description:
      "Comprehensive testing services that ensure your product's reliability. From functional to security testing, we ensure top-tier performance and security.",
    icon: <BugReport fontSize="large" sx={{ color: "white" }} />, // Red color
    bgColor: "linear-gradient(145deg, #43a047, #66bb6a)",
  },
  {
    title: "Cybersecurity Development",
    description:
      "Cutting-edge cybersecurity solutions to protect your infrastructure. We offer encryption, threat detection, and real-time monitoring for your digital security.",
    icon: <Shield fontSize="large" sx={{ color: "white" }} />, // Purple color
    bgColor: "linear-gradient(145deg, #c2185b, #d81b60)",
  },
];

const OurServices = () => {
  const theme = useTheme();

  return (
    <Box sx={{ backgroundColor: "#e6f2ff", py: 5 }}>
      <PageTransition>
        <Container>
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Typography variant="h4" sx={{ color: theme.palette.secondary.main, fontWeight: 800, mb: 3 }}>
              Our Services
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                maxWidth: 800,
                mx: "auto",
                mb: 6,
                fontWeight: 300,
                fontSize: "1rem",
                lineHeight: 1.8,
              }}
            >
              We bring innovative solutions with a focus on quality, security, and performance. Our expert team delivers
              cutting-edge services to meet your business needs.
            </Typography>
          </Box>

          <Grid container spacing={6}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: 4,
                    background: service.bgColor,
                    transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
                    ":hover": {
                      transform: "translateY(-8px)",
                      boxShadow: 12,
                    },
                  }}
                >
                  <CardContent sx={{ padding: 4, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                      {service.icon}
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          color: "#fff",
                          ml: 2,
                          fontSize: "1.2rem",
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        {service.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#fff",
                        lineHeight: 1.6,
                        fontSize: "1rem",
                      }}
                    >
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </PageTransition>
    </Box>
  );
};

export default OurServices;
